// extracted by mini-css-extract-plugin
export default {"container":"sJEk_O","icon":"lt2emW","message":"gKdr35"};